export default "/TOUCOIN.0c195fd2d9e355cc340564502125f30d.svg";